<template>
  <div class="left_block groups">
    <p class="header">
      <router-link :to="'/groups'">
        <span class="link"> Все группы <i style="font-size: 10px;" class="icon-button-arrow"></i> </span>
      </router-link>
      {{ `Группа ${groupInfo.id}. ${groupInfo.name || ''}` }}
    </p>

    <GroupActions
      :group-info="groupInfo"
      @edit="openEditModal"
      @delete="deleteGroup"
      @add-course="openCourseAddModal"
      @add-user="openUserAddModal"
    />

    <p class="actions_header">
      <span class="left">Пользователи в группе</span>
      <button class="right" @click="detachUsers(checked.users.map((user) => user.id))" :disabled="!checked.users.length">
        <i class="mdi mdi-account-remove-outline"></i> Убрать пользователей из списка (отмеченные)
      </button>
    </p>

    <GroupUsersTable
      :users-list="groupUsers"
      :checked="checked"
      :total-count="totalGroupUsers"
      :is-loading="isGroupUsersLoading"
      :search="search"
      @changePage="loadGroupUsers"
      @detach="detachUsers"
    />

    <b-modal :active.sync="isEditModalOpen" has-modal-card scroll="keep">
      <GroupsCreate
        :new-group="newGroup"
        :modal-info="modal"
        @close-modal="closeEditModal"
        @edit="edit"
      />
    </b-modal>

    <b-modal :active.sync="isUserAddModalOpen" has-modal-card scroll="keep">
      <UserAddModal
        :users-list="usersList"
        :checked="checked"
        :search="search"
        :total="totalUsers"
        @close-modal="closeUserAddModal"
        @pageChange="loadUsers"
        @submit="attachUsers"
      />
    </b-modal>

    <b-modal @close="closeCourseAddModal" :active.sync="isCourseAddModalOpen" has-modal-card scroll="keep">
      <CourseAddModal
        @attach="attachCourses"
        :checked="checked"
        :user-courses="[]"
        :modal-info="courseAddInfo"
        :categories-list="categoriesList"
        @close="closeCourseAddModal"
      />
    </b-modal>
  </div>
</template>

<script>
import GroupUsersTable from '@/components/admin/groups/GroupUsersTable';
import CourseAddModal from '@/components/admin/groups/CourseAddModal';
import GroupActions from '@/components/admin/groups/GroupActions';
import GroupsCreate from '@/components/admin/groups/GroupsCreate';
import UserAddModal from '@/components/admin/groups/UserAddModal';
import { toastInfo } from '../../lib/toastCfg';

export default {
  components: { GroupActions, GroupsCreate, UserAddModal, GroupUsersTable, CourseAddModal },
  data() {
    return {
      isEditModalOpen: false,
      isUserAddModalOpen: false,
      isCourseAddModalOpen: false,
      isUsersLoading: false,
      isGroupUsersLoading: false,
      newGroup: { name: '' },
      modal: {
        header: 'Редактирование группы',
        button: 'Сохранить',
        action: 'edit',
        creation: false,
        required: false,
      },
      checked: {
        users: [],
        ids: [],
      },
      search: {
        usersPage: 1,
        groupUsersPage: 1,
      },
      courseAddInfo: {
        date_start: new Date(),
      },
    }
  },
  computed: {
    usersList() {
      return this.$store.state.allUsers.usersList.users;
    },
    totalUsers() {
      return Number(this.$store.state.allUsers.usersList.total);
    },
    groupInfo() {
      return this.$store.state.groups.groupInfo;
    },
    groupUsers() {
      return this.$store.state.groups.groupUsers.users;
    },
    totalGroupUsers() {
      return Number(this.$store.state.groups.groupUsers.total);
    },
    groupId() {
      return Number(this.$route.params.id);
    },
    branchesList() {
      return this.$store.state.right.rightBranchesList;
    },
    categoriesList() {
      return this.$store.state.categories.categoriesList;
    },
  },
  methods: {
    loadGroupUsers() {
      this.isGroupUsersLoading = true;
      return this.$axios2
        .get(`groups/users/${this.groupId}?page=${this.search.groupUsersPage}`)
        .then((resp) => {
          const data = {
            ...resp.data,
            data: resp.data.data.map((user) => {
              const userBranch = this.branchesList.find((branch) => branch.id === user.branch_id);
              if (!userBranch) return { ...user, branch: { id: 0, name: '' }};
              return {
                ...user,
                branch: {
                  id: userBranch.id,
                  name: userBranch.name,
                },
              }
            }),
          };
          return this.$store.commit('setGroupUsersList', { list: data });
        })
        .catch(this.$errorToast)
        .finally(() => this.isGroupUsersLoading = false);
    },
    loadData() {
      this.$axios2
        .get(`groups/${this.groupId}`)
        .then((resp) => {
          this.$store.commit('setGroupInfo', { list: resp.data });
        })
        .catch(this.$errorToast);
    },
    edit() {
      this.$axios2.post(`groups/${this.groupId}`, this.newGroup).then((resp) => {
        this.$store.commit('setGroupInfo', { list: resp.data });
        this.$buefy.toast.open(toastInfo());
        this.loadData();
        this.closeEditModal();
      })
      .catch(this.$errorToast);
    },
    deleteGroup() {
      this.$axios2
        .delete(`groups/${this.groupId}`)
        .then(() => {
          this.$buefy.toast.open(toastInfo());
          this.$router.push('/groups');
        })
        .catch(this.$errorToast);
    },
    openEditModal() {
      this.newGroup = { ...this.groupInfo };
      this.isEditModalOpen = true;
    },
    closeEditModal() {
      this.isEditModalOpen = false;
    },
    attachCourses() {
      this.checked.ids.forEach((course_id) => {
        this.$axios2.post(`groups/${this.groupId}/assign_course/${course_id}`, { course_ids: this.checked.ids }).then(() => {
          this.$buefy.toast.open(toastInfo());
        })
        .catch(this.$errorToast);
        this.closeCourseAddModal();
      });
    },
    openCourseAddModal() {
      this.isCourseAddModalOpen = true;
    },
    closeCourseAddModal() {
      this.isCourseAddModalOpen = false;
      this.checked.ids = [];
    },
    openUserAddModal() {
      this.loadUsers().then(() => this.isUserAddModalOpen = true);
    },
    loadUsers() {
      if (this.isUsersLoading) return;
      this.isUsersLoading = true;
      return this.$axios2
        .get(`users?role=2&page=${this.search.usersPage}`)
        .then((resp) => {
          return this.$store.commit('setUsersList', { list: resp.data });
        })
        .catch(this.$errorToast)
        .finally(() => this.isUsersLoading = false);
    },
    closeUserAddModal() {
      this.isUserAddModalOpen = false;
      this.checked.users = [];
    },
    attachUsers() {
      this.$axios2.post(`groups/${this.groupId}/user`, { user_ids: this.checked.users }).then(() => {
        this.$buefy.toast.open(toastInfo());
        this.loadGroupUsers();
        this.closeUserAddModal();
      })
      .catch(this.$errorToast);
    },
    detachUsers(user_ids) {
      this.$axios2.delete(`groups/${this.groupId}/user`, { data: { user_ids } }).then(() => {
        this.$buefy.toast.open(toastInfo());
        this.loadGroupUsers();
        this.checked.users = [];
      })
      .catch(this.$errorToast);
    },
  },
  mounted() {
    this.loadData();
    this.loadGroupUsers();
  },
}
</script>
